import { paymentPageReducer, PaymentPageState } from "./reducers/paymentPageReducer"
import { ModalState, modalReducer } from "./reducers/modalReducer"
import { combineReducers } from "redux"
import { HostedFieldsState, hostedFiledsReducer } from "./reducers/hostedFieldsReducer"
import { configurationReducer, ConfigurationState } from "./reducers/configurationReducer"

export interface StoreState {
    modal: ModalState
    paymentPage: PaymentPageState
    hostedFields: HostedFieldsState
    configuration: ConfigurationState
}

export const createRootReducer = () =>
    combineReducers<StoreState>({
        modal: modalReducer,
        paymentPage: paymentPageReducer,
        hostedFields: hostedFiledsReducer,
        configuration: configurationReducer,
    })
